import {
  BenefitOrigin,
  BenefitPackage,
  type BenefitsAPI,
  BenefitType,
} from '@omnipresentgroup/types';

export const DEFAULT_BENEFITS: BenefitsAPI = {
  benefits: [
    {
      country: {
        code: 'CA',
        name: 'Canada',
        flag: '🇨🇦',
      },
      client_id: '12345',
      employee_external_id: 'GI-21-28921050',
      employee_id: 'GI-21-28921050',
      employee_name: 'Jordan Patel',
      package: BenefitPackage.STANDARD,
      benefit_effective_date: '2022-01-17T00:00:00Z',
      mandatory: false,
      benefit_type: BenefitType.DENTAL,
      vendor: 'Manulife',
      coverage: 'single',
      number_of_dependents: 0,
      benefits_currency: 'CAD',
      employer_cost: {
        amount: 136.64,
        currency: 'CAD',
      },
      origin: BenefitOrigin.OMNI_ENTITY,
      payroll_period: 'monthly',
    },
    {
      country: {
        code: 'ES',
        name: 'Spain',
        flag: '🇪🇸',
      },
      client_id: '12345',
      employee_external_id: 'GI-21-28921050',
      employee_id: 'GI-21-28921050',
      employee_name: 'Jordan Patel',
      package: BenefitPackage.STANDARD,
      benefit_effective_date: '2022-01-17T00:00:00Z',
      mandatory: false,
      benefit_type: BenefitType.GROUP_LIFE_AND_WORK_INJURY,
      vendor: 'Manulife',
      coverage: 'single',
      number_of_dependents: 0,
      benefits_currency: 'CAD',
      employer_cost: {
        amount: 136.64,
        currency: 'CAD',
      },
      origin: BenefitOrigin.OMNI_ENTITY,
      payroll_period: 'monthly',
    },
    {
      country: {
        code: 'FR',
        name: 'France',
        flag: '🇫🇷',
      },
      client_id: '12345',
      employee_external_id: 'GI-21-28921050',
      employee_id: 'GI-21-28921050',
      employee_name: 'Jordan Patel',
      package: BenefitPackage.STANDARD,
      benefit_effective_date: '2022-01-17T00:00:00Z',
      mandatory: false,
      benefit_type: BenefitType.GROUP_LIFE_AND_WORK_INJURY,
      vendor: 'Manulife',
      coverage: 'single',
      number_of_dependents: 0,
      benefits_currency: 'CAD',
      employer_cost: {
        amount: 136.64,
        currency: 'CAD',
      },
      origin: BenefitOrigin.OMNI_ENTITY,
      payroll_period: 'monthly',
    },
    {
      country: {
        code: 'CA',
        name: 'Canada',
        flag: '🇨🇦',
      },
      client_id: '12345',
      employee_external_id: 'GI-21-28921050',
      employee_id: 'GI-21-28921050',
      employee_name: 'Jordan Patel',
      package: BenefitPackage.STANDARD,
      benefit_effective_date: '2022-01-17T00:00:00Z',
      mandatory: false,
      benefit_type: BenefitType.LIFE_INSURANCE,
      vendor: 'Manulife',
      coverage: 'single',
      number_of_dependents: 0,
      benefits_currency: 'CAD',
      employer_cost: {
        amount: 21.66,
        currency: 'CAD',
      },
      origin: BenefitOrigin.OMNI_ENTITY,
      payroll_period: 'monthly',
    },
    {
      country: {
        code: 'CA',
        name: 'Canada',
        flag: '🇨🇦',
      },
      client_id: '12345',
      employee_external_id: 'GI-21-28921050',
      employee_id: 'GI-21-28921050',
      employee_name: 'Jordan Patel',
      package: BenefitPackage.STANDARD,
      benefit_effective_date: '2022-01-17T00:00:00Z',
      mandatory: false,
      benefit_type: BenefitType.LIFE_INSURANCE,
      vendor: 'Manulife',
      coverage: 'single',
      number_of_dependents: 0,
      benefits_currency: 'CAD',
      employer_cost: {
        amount: 21.66,
        currency: 'CAD',
      },
      origin: BenefitOrigin.OMNI_ENTITY,
      payroll_period: 'monthly',
    },
    {
      benefit_effective_date: '2023-01-01T00:00:00Z',
      benefit_type: BenefitType.ACCIDENT_DEATH_AND_DISABILITY,
      benefits_currency: 'USD',
      client_id: '12345',
      country: {
        code: 'US',
        name: 'United States',
        flag: '🇺🇸',
      },
      employee_external_id: '67890',
      employee_id: '123456',
      employee_name: 'John Doe',
      employer_cost: {
        amount: 1000,
        currency: 'USD',
      },
      lsp_id: 'abc123',
      number_of_dependents: 34,
      payroll_period: 'monthly',
      vendor: 'XYZ Benefits',
      origin: BenefitOrigin.OMNI_ENTITY,
      coverage: 'Full Coverage',
      employee_deduction: {
        amount: 50,
        currency: 'USD',
      },
      mandatory: true,
      package: BenefitPackage.BRONZE,
      pension_details: {
        employer_amount: {
          amount: 500,
          currency: 'USD',
        },
        employee_amount: {
          amount: 200,
          currency: 'USD',
        },
        employee_voluntary_contribution_amount: {
          amount: 100,
          currency: 'USD',
        },
      },
    },
    {
      benefit_effective_date: '2023-01-01T00:00:00Z',
      benefit_type: BenefitType.LONG_TERM_DISABILITY,
      benefits_currency: 'USD',
      client_id: '12345',
      country: {
        code: 'US',
        name: 'United States',
        flag: '🇺🇸',
      },
      employee_external_id: '67890',
      employee_id: '123456',
      employee_name: 'Tom Yorke',
      employer_cost: {
        amount: 1000,
        currency: 'USD',
      },
      lsp_id: 'abc123',
      number_of_dependents: 34,
      payroll_period: 'monthly',
      vendor: 'XYZ Benefits',
      origin: BenefitOrigin.LSP,
      package: BenefitPackage.GOLD,
    },
    {
      benefit_effective_date: '2023-01-01T00:00:00Z',
      benefit_type: BenefitType.DENTAL,
      benefits_currency: 'USD',
      client_id: '12345',
      country: {
        code: 'US',
        name: 'United States',
        flag: '🇺🇸',
      },
      employee_external_id: '67890',
      employee_id: '123456',
      employee_name: 'Alice Smith',
      employer_cost: {
        amount: 1000,
        currency: 'USD',
      },
      lsp_id: 'abc123',
      number_of_dependents: 34,
      payroll_period: 'monthly',
      vendor: 'XYZ Benefits',
      origin: BenefitOrigin.OMNI_ENTITY,
      coverage: 'Full Coverage',
      employee_deduction: {
        amount: 50,
        currency: 'USD',
      },
      mandatory: true,
      package: BenefitPackage.SILVER,
      pension_details: {
        employer_percentage: '5',
        employee_percentage: '3',
        employee_voluntary_contribution_percentage: '2',
      },
    },
    {
      benefit_effective_date: '2023-01-01T00:00:00Z',
      benefit_type: BenefitType.GROUP_LIFE_AND_WORK_INJURY,
      benefits_currency: 'USD',
      client_id: '12345',
      country: {
        code: 'UK',
        name: 'United Kingdom',
        flag: '🇬🇧',
      },
      employee_external_id: '67890',
      employee_id: '123456',
      employee_name: 'Teresa Green',
      employer_cost: {
        amount: 1000,
        currency: 'USD',
      },
      lsp_id: 'abc123',
      number_of_dependents: 34,
      payroll_period: 'monthly',
      vendor: 'XYZ Benefits',
      origin: BenefitOrigin.LSP,
      package: BenefitPackage.GOLD,
    },
    {
      benefit_effective_date: '2023-01-01T00:00:00Z',
      benefit_type: BenefitType.GROUP_LIFE_AND_WORK_INJURY,
      benefits_currency: 'USD',
      client_id: '12345',
      country: {
        code: 'UK',
        name: 'United Kingdom',
        flag: '🇬🇧',
      },
      employee_external_id: '67890',
      employee_id: '123456',
      employee_name: 'Bob Brown',
      employer_cost: {
        amount: 1000,
        currency: 'USD',
      },
      lsp_id: 'abc123',
      number_of_dependents: 34,
      payroll_period: 'monthly',
      vendor: 'XYZ Benefits',
      origin: BenefitOrigin.OMNI_ENTITY,
    },
  ],
  last_updated: '2023-01-01',
};
